import React, { memo } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { IExtendedMetric } from "@modules/ServiceProviders/types/serviceProvider.types";
import { MetricCard } from "../MetricCard";
import { MetricProgressBar } from "../MetricProgressBar";
import { MetricProgressFooter } from "../MetricProgressFooter";
import messages from "../messages";

interface ITopPickCard {
  metric: IExtendedMetric | undefined;
  onClick?: () => void;
}

export const TopPickCard = memo(({ metric, onClick }: ITopPickCard) => {
  const value = Number(metric?.value ?? 0);
  const threshold = Number(metric?.threshold ?? 20);
  const reached =
    metric !== undefined && metric.value !== null && metric.threshold !== null && value >= threshold;

  const offersCount = metric?.computationDetails?.offersSentCount ?? 0;
  const selectionsCount = metric?.computationDetails?.selectionsCount ?? 0;

  return (
    <MetricCard
      title={<FormattedMessage {...messages.topPickTitle} />}
      description={
        <FormattedMessage
          {...messages.minThreshold}
          values={{ value: threshold }}
        />
      }
      state={reached ? "reached" : "not-reached"}
      onClick={onClick}
      percentage={value}
      footer={
        <MetricProgressFooter
          text={
            <FormattedMessage
              {...messages.assignmentFooter}
              values={{ count: selectionsCount, total: offersCount }}
            />
          }
        />
      }
    >
      <MetricProgressBar value={value} threshold={threshold} />
    </MetricCard>
  );
});

TopPickCard.displayName = "TopPickCard";
